import type {BioSort} from "~/models/assortments";

export const SORT_BIOVIRKE = '6838f465-2161-e411-82a8-00155da5a31b'
export const SORT_BIOVIRKE_100_PROSENT_PEFC = 'c8d12e48-cc2d-e811-80d6-00155da51821'
export const SORT_BIOVIRKE_RED = '6638f465-2161-e411-82a8-00155da5a31b'
export const SORT_HELTRE = '6a38f465-2161-e411-82a8-00155da5a31b'
export const SORT_GROT = '6e38f465-2161-e411-82a8-00155da5a31b'
export const SORT_605_LAUV_BL_HARDVED = '0ef9fb5f-2161-e411-82a8-00155da5a31b'
export const SORT_945_LAUV_MV_BLAND = '6d1ef738-eea0-eb11-b9f6-00155d0ade24'

export const SORTS: BioSort[] = [
  {
    Id: 10,
    Guid: '12C656DD-5661-E411-82A8-00155DA5A31B',
    Name: 'Gran'
  },
  {
    Id: 12,
    Guid: '14C656DD-5661-E411-82A8-00155DA5A31B',
    Name: 'Sitka'
  },
  {
    Id: 13,
    Guid: '16C656DD-5661-E411-82A8-00155DA5A31B',
    Name: 'Hemlock'
  },
  {
    Id: 15,
    Guid: '18C656DD-5661-E411-82A8-00155DA5A31B',
    Name: 'Edelgran'
  },
  {
    Id: 20,
    Guid: '1AC656DD-5661-E411-82A8-00155DA5A31B',
    Name: 'Furu'
  },
  {
    Id: 25,
    Guid: '1CC656DD-5661-E411-82A8-00155DA5A31B',
    Name: 'Lerk'
  },
  {
    Id: 30,
    Guid: '20C656DD-5661-E411-82A8-00155DA5A31B',
    Name: 'Bjørk'
  },
  {
    Id: 31,
    Guid: '22C656DD-5661-E411-82A8-00155DA5A31B',
    Name: 'Osp'
  },
  {
    Id: 32,
    Guid: '24C656DD-5661-E411-82A8-00155DA5A31B',
    Name: 'Or'
  },
  {
    Id: 33,
    Guid: '26C656DD-5661-E411-82A8-00155DA5A31B',
    Name: 'Selje'
  },
  {
    Id: 35,
    Guid: '2AC656DD-5661-E411-82A8-00155DA5A31B',
    Name: 'Ask'
  },
  {
    Id: 36,
    Guid: '2CC656DD-5661-E411-82A8-00155DA5A31B',
    Name: 'Eik'
  },
  {
    Id: 37,
    Guid: '2EC656DD-5661-E411-82A8-00155DA5A31B',
    Name: 'Lind'
  },
  {
    Id: 39,
    Guid: '32C656DD-5661-E411-82A8-00155DA5A31B',
    Name: 'Alm'
  }
]

export const BIO_SORT_EXCLUSIONS = [
  {
    Sort: SORT_605_LAUV_BL_HARDVED,
    Exclusions: [10,12,15]
  },
  {
    Sort: SORT_945_LAUV_MV_BLAND,
    Exclusions: [10,12,15]
  },
]

export const END_PRODUCT_SAW_TIMBER = 1
export const END_PRODUCT_PULP_WOOD = 2

export const ASSORTMENT_NO_WOOD_FOR_OWN_USE = 933
